import script from "./ContractList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractList.vue?vue&type=script&setup=true&lang=ts"

import "./ContractList.vue?vue&type=style&index=0&id=10826588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10826588"]])

export default __exports__